(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/self-exclusion-not-player.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/self-exclusion-not-player.js');
'use strict';

const _svs$selfExclusion$co = svs.selfExclusion.components,
  NationalSelfExclusion = _svs$selfExclusion$co.NationalSelfExclusion,
  Information = _svs$selfExclusion$co.Information,
  LoginSelfExclusion = _svs$selfExclusion$co.LoginSelfExclusion;
const SelfExclusionNotPLayer = () => React.createElement("section", {
  id: "self-exclusion-overview"
}, React.createElement(LoginSelfExclusion, null), React.createElement(NationalSelfExclusion, null), React.createElement(Information, null));
svs.selfExclusion.components.SelfExclusionNotPLayer = SelfExclusionNotPLayer;

 })(window);